/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PixtaThumbnailImage,
    PixtaThumbnailImageFromJSON,
    PixtaThumbnailImageFromJSONTyped,
    PixtaThumbnailImageToJSON,
} from './PixtaThumbnailImage';

/**
 * サーバーに保存されたPIXTA画像のデータ
 * @export
 * @interface PixtaSearchedItem
 */
export interface PixtaSearchedItem {
    /**
     * PIXTA画像ID
     * @type {number}
     * @memberof PixtaSearchedItem
     */
    id: number;
    /**
     * 画像購入URL
     * @type {string}
     * @memberof PixtaSearchedItem
     */
    affiliateUrl: string;
    /**
     * 画像タイトル
     * @type {string}
     * @memberof PixtaSearchedItem
     */
    title: string;
    /**
     * 
     * @type {PixtaThumbnailImage}
     * @memberof PixtaSearchedItem
     */
    thumbnailImage: PixtaThumbnailImage;
}

export function PixtaSearchedItemFromJSON(json: any): PixtaSearchedItem {
    return PixtaSearchedItemFromJSONTyped(json, false);
}

export function PixtaSearchedItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PixtaSearchedItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'affiliateUrl': json['affiliate_url'],
        'title': json['title'],
        'thumbnailImage': PixtaThumbnailImageFromJSON(json['thumbnail_image']),
    };
}

export function PixtaSearchedItemToJSON(value?: PixtaSearchedItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'affiliate_url': value.affiliateUrl,
        'title': value.title,
        'thumbnail_image': PixtaThumbnailImageToJSON(value.thumbnailImage),
    };
}

